import React from 'react'
import Back from '../../Public/Image/Home/Back.svg'
import '../GetLinkUsername.css'
import TextField from '@mui/material/TextField';
import CheckUsername from '../../BottomSheet/CheckUsername';
import ShowPriceAndChannel from '../../BottomSheet/ShowPriceAndChannel';
import { useState } from 'react';
import { setBottomSheetCheckUsername } from '../../app/Home'
import { setUserNameForOrder } from '../../app/Home'
import { GetCookie } from '../../Action/GetCookie';
// import { CheckChannelBeforePurchase } from './../Api/CheckChannelBeforePurchase'
import { AllApi } from '../../Api/AllApi'
import { BottomSheet } from 'react-spring-bottom-sheet'
import CoinBottomSheet from './../../Public/Image/Home/CoinBottomSheet.svg'

import { useSelector, useDispatch } from 'react-redux'
import TooManyOrders from '../../BottomSheet/TooManyOrders'
import TooManyOrdersUser from '../../BottomSheet/TooManyOrdersUser'
import { setBottomSheetTooManyOrdersUser } from '../../app/Home'
import { setBottomSheetTooManyOrdersUserTitle } from '../../app/Home'
import { setBottomSheetTooManyOrdersUserDescription } from '../../app/Home'

import ViolatingChannel from '../../BottomSheet/ViolatingChannel'
import { setBottomSheetTooManyOrders } from '../../app/Home'
import { setBottomSheetViolatingChannel } from '../../app/Home'
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ShowPriceAndChannelCoin from '../../BottomSheet/ShowPriceAndChannelCoin'

import { setMiniLoading } from '../../app/Home'
import { useHistory } from 'react-router-dom';
// import useStore from '../../Zustand/Reaction' // مسیر فایل zustand
import warning from '../../Public/Image/Home/warning.svg'
import PersonIcon from '@mui/icons-material/Person';
import useStore from '../../Zustand/checkReactBeforePurchase' // مسیر فایل zustand
import saveReactByCoin from '../../Zustand/saveReactByCoin'

import cryptlib from "cryptlib"
// import useStore from '../../Zustand/AppSetting' // مسیر فایل zustand

import { GameDB } from '../../DataBase/GameDB'

import { SetCookie } from './../../Action/SetCookie'
import Member from './../../Public/Image/wheel/member.png'
import Cryptoicon from '../../Public/Image/Home/cryptoicon.svg'
import CryptoDisableicon from '../../Public/Image/Home/CryptoDisable.svg'
import PayPalIcon from '../../Public/Image/Home/PayPalIcon.png'
import UnsuccessfulPayment from '../../BottomSheet/UnsuccessfulPayment';
import SuccessfulPayment from '../../BottomSheet/SuccessfulPayment';
import { setBottomSheetsuccessfulPayment } from '../../app/Home'
import { setBottomSheetUnsuccessfulPayment } from '../../app/Home'

const ReactionGetPostLink = () => {
    const dispatch = useDispatch()
    const MiniLoading = useSelector((state) => state.Home.MiniLoading)
    const IsIranian = useSelector((state) => state.Home.IsIranian)
    const Token = GetCookie('Token')
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const Emoji = searchParams.get('Emoji');
    const Price = searchParams.get('Price');
    const Count = searchParams.get('Count');
    const _id = searchParams.get('_id');
    const sku = searchParams.get('sku');
    const ByCoin = searchParams.get('ByCoin');
    // const emoji = searchParams.get('ByCoin');
    // console.log(Price)
    const history = useHistory();
    const [BottomSheetstate, setBottomSheetState] = useState(false)
    function onDismiss() {
        setTimeout(() => {
            setBottomSheetState(false)
        }, 300);
    }
    const { fetchData } = useStore()
    const { saveReactByCoinRes } = saveReactByCoin(); // مربوط به لیست ری‌اکت‌ها

    const UserFromApi = useSelector((state) => state.Home.UserFromApi)

    const [ServerError, setServerError] = useState(null)
    const [MemberReward, setMemberReward] = useState(false)
    const [MemberRewardCount, setMemberRewardCount] = useState('')


    const HandleUsernameLink = async () => {
        dispatch(setMiniLoading(true))


        let result = LastUsername.trim();

        result = result.toLowerCase();
        setUsernameErrorEmpty(false)
        setUsernameError(false)
        let PositionLink = result.search("https://t.me/");
        let PositionSign = result.search("@");
        if (PositionLink == 0) {

            result = result.replace('https://t.me/', '');

        } else if (PositionSign == 0) {

            result = result.replace('@', '');

        } else {
            result = result
        }

        if (result.length > 4) {
            if (isValidTelegramUsername(result)) {
                setUsernameError(false)

            } else {

                setUsernameError(true)
            }
        } else {
            setUsernameError(false)

        }



        if (result.length == 0) {
            setUsernameErrorEmpty(true)
            dispatch(setMiniLoading(false))

        } else {

            if (UsernameError == false && UsernameErrorEmpty == false) {
                if (result.length < 4 && result.length >= 0) {
                    setUsernameError(true)
                } else {


                    // console.log(LastUsername)
                    // console.log(LastPostId)
                    // console.log(_id)
                    if (Price == '0') {
                        const api = new AllApi();

                        let gift = JSON.parse(localStorage.getItem("GiftUser"))
                        // console.log(gift.token, result)
                        // console.log(LastPostId)
                        let UserNameForOrder = result
                        let messageIds = [LastPostId]
                        const res = await api.SaveSpin(gift.token, Token, UserNameForOrder, messageIds, Emoji)
                        // console.log(res)
                        if (res.code === 301) {
                            // console.log('You have already claimed the reward!')
                        } else if (res.code == 200) {
                            setMemberRewardCount(gift.gift)

                            setMemberReward(true)
                            SetCookie('Gifttoken', null, -100);
                            localStorage.removeItem('GiftUser')
                        }
                    } else {
                        const res = await fetchData(LastUsername, LastPostId, _id);
                        // console.log("✅ Decrypted API result:", res);
                        if (res.code == 200) {

                            setBottomSheetState(true)


                            setServerError(null)

                        } else if (res.code == 301) {
                            // اگر فرمت  usernaem اشتباه باشه خطای 301 میگیره
                            setServerError(res.message)
                        } else if (res.code == 302) {
                            // اگرکانال فیلتر بود خطای 302 میگیره
                            setServerError(res.message)

                        } else if (res.code == 303) {
                            // console.log(res)
                            // console.log(res.code)
                            setServerError(res.message)

                            // اگر یک پست خاص به  limit خورد و سقف ظرفیت رو گرفته باشه خطای 303 میگیره
                        } else if (res.code == 304) {
                            setServerError(res.message)

                            // اگر something went wrong بود خطای304 میگیره

                        }
                        else if (res.code == 120 || res.code == 121 || res.code == 122 || res.code == 123) {
                            let name = "Token"
                            let name1 = "active"
                            document.cookie = name + '=; Max-Age=-99999999;';
                            document.cookie = name1 + '=; Max-Age=-99999999;';


                            history.push("/");
                            // dispatch(setLoading(false))

                        }
                    }


                }
                dispatch(setMiniLoading(false))
            }


        }


    }






    const [ButtonState, setButtonState] = useState(null)
    const [LastUsername, setLastUsername] = useState('')
    const [LastPostId, setLastPostId] = useState('')
    const [Username, setUsername] = useState('')
    const [UsernameError, setUsernameError] = useState(false)
    const [UsernameErrorEmpty, setUsernameErrorEmpty] = useState(false)
    // const telegramUsernameRegex = /^[a-zA-Z][a-zA-Z0-9_]{3,31}$/;
    const telegramUsernameRegex = /^[a-zA-Z][a-zA-Z0-9_]{3,30}[a-zA-Z0-9]$/;

    function isValidTelegramUsername(username) {
        return telegramUsernameRegex.test(username);
    }
    function extractUsernameAndPostId(url) {
        // const regex = /https:\/\/t.me\/([^\/]+)\/(\d+)/;
        const regex = /^https:\/\/t\.me\/([^\/]+)\/(\d+)(?:\?.*)?$/;
        const match = url.match(regex);
        let Error;
        if (match && match.length === 3) {
            const username = match[1];
            const postId = match[2];

            // Check if the entire URL matches the expected format
            if (url.length === match[0].length) {
                return { username, postId };
            } else {
                Error = 'Invalid URL length. Please provide a valid Telegram URL.'
                // throw new Error('Invalid URL length. Please provide a valid Telegram URL.');
            }
        } else {
            Error = 'Invalid URL length. Please provide a valid Telegram URL.'

        }
        return Error
    }

    const HandleChange = (value) => {
        // OnePost
        // console.log(value)
        let result = value.trim();
        result = result.toLowerCase();
        setUsername(result)

        setUsernameErrorEmpty(false)
        setUsernameError(false)
        setLastUsername(result)
        const resultid = extractUsernameAndPostId(value);
        // console.log(resultid)
        if (resultid == 'Invalid URL length. Please provide a valid Telegram URL.') {
            if (value.length > 4) {

                setButtonState(true)
                setUsernameError(true)
            }
        } else {
            setButtonState(false)

            if (result.length > 0) {

                if (resultid) {
                    let responseV = isValidTelegramUsername(resultid.username)
                    // console.log(responseV)
                    if (responseV == true) {
                        // console.log(resultid.postId)
                        setLastUsername(resultid.username)
                        setLastPostId(Number(resultid.postId))

                        //  dispatch(setPostLink(resultid.postId))
                        setUsernameError(false)
                    } else {

                        setUsernameError(true)

                    }

                } else {

                    setUsernameError(true)

                }
            } else {

                setUsernameError(false)
            }
        }

    }
    const Email = useSelector((state) => state.counter.email)
    const iv = '#GV^%^SUR&T*#Y*4'
    const key = cryptlib.getHashSha256('#GV^%^SUR&T*#Y*4', 32);
    const user = {
        // "phonenumber": "989373449122",
        "email": Email,
        //    "email": "testphoenixmlk@gmail.com",
        "_id": _id, // بسته _id
        "sku": sku,
        "price": Price,
        "username": LastUsername,
        "phonenumber": UserFromApi.phonenumber,
        "messageIds": [LastPostId],
        "emoji": Emoji
    }
    // console.log(user)
    let data = cryptlib.encrypt(JSON.stringify(user), key, iv);
    const Pay = async (data) => {
        dispatch(setMiniLoading(true))
        // console.log(LastPostId)
        // console.log(Price)

        if (ByCoin == 'true') {
            const user1 = {
                data: {
                    // "phonenumber": "989373449122",
                    "email": Email,
                    "_id": _id, // بسته _id
                    "sku": sku,
                    "price": Price,
                    "username": LastUsername,
                    "messageIds": [LastPostId],
                    "emoji": Emoji,

                }

            }
            // console.log(user1)
            // const MakeApiClass = new AllApi();
            // let res = await MakeApiClass.SaveViewByCoin(user1)
            let res = await saveReactByCoinRes(user1)
            // let res = await SaveViewByCoin(user1)
            //   /main/v1/paypal/purchasereactpaypal
            // console.log(res)

            if (res.code == 200) {
                // dispatch(setUserCoin(res.data.user.coins))


                history.push(`/Home?paymentreact=true&username=${LastUsername}&count=${Count}&point=${res.data.user.point}&countPost=${res.data.user.countPost}&emoji=${Emoji}&id=${LastPostId}`);
            } else if (res.code == 120 || res.code == 121 || res.code == 122 || res.code == 123) {
                let name = "Token"
                let name1 = "active"
                document.cookie = name + '=; Max-Age=-99999999;';
                // console.log(234)

                document.cookie = name1 + '=; Max-Age=-99999999;';
                history.push("/");
                // dispatch(setLoading(false))

            } else if (res.code == 302) {
                // dispatch(setBottomSheetViolatingChannel(true))
            } else {
                history.push(`/Home?paymentreact=false&username=null&count=null`);

            }
        } else if (ByCoin == 'false') {
            if (PaymentWay == 'Cryptomus') {
                if (CanUseWallet == true) {
                    const MakeApiClass = new AllApi();

                    let res = await MakeApiClass.Cryptogetreact(sku, LastUsername, _id, Emoji, LastPostId)
                    if (res.code == 200) {
                        // console.log(res.code)
                        dispatch(setBottomSheetsuccessfulPayment(true))
                        setBottomSheetState(false)
                    } else {
                        dispatch(setBottomSheetUnsuccessfulPayment(true))

                    }
                    // https://pay.cryptomus.com/pay/92962cb0-191f-4f0c-b312-35e2af8dc8c8
                } else {
                    window.location.href = `https://api.membersgram.com/main/v1/crypto/react?data=${data}`
                }

            } else {
                // console.log(data)
                if (IsIranian == false) {
                    // console.log(data)
                    window.location.href = `https://api.membersgram.com/main/v1/webapp/purchasereactpaypal?data=${data}`
                } else if (IsIranian == true) {
                    window.location.href = `https://api.membersgram.com/main/v1/webapp/zarinpal/react/gateway?data=${data}`

                }
            }

            // window.location.href = `https://api.membersgram.com/main/v1/webapp/purchaseviewpaypal?data=${data}`
        }


        // dispatch(setBottomSheetViewShowPriceAndChannel(false))

        dispatch(setMiniLoading(false))

    }



    //  const { market, data, loading, error, fetchData } = useStore()

    //   useEffect(() => {

    //     fetchData('WebAppP')
    //   }, [])
    //   const emojiList = data?.data?.appSetting?.emojiList || [];
    // let EmojiItem
    const [EmojiItem, setEmojiItem] = useState('')
    const GetAppSetting = async () => {
        let AppSetting = await GameDB.AppSetting.toArray()
        // console.log(AppSetting[0].AppSetting.emojiList)
        const emojiList = AppSetting[0].AppSetting.emojiList
        // console.log(emojiList)
        let Emoj = emojiList.find(item => item.emoji === Emoji);
        setEmojiItem(Emoj)
        // Emoji
    }
    const [CryptoDisable, setCryptoDisable] = useState(true)

    useEffect(() => {
        console.log(Number(Price))
        if (Number(Price) >= limit_cryptomus) {
            // console.log('first')
            setCryptoDisable(false)

        } else {
            // console.log('123')
            setCryptoDisable(true)
        }
        GetAppSetting()
    }, [])
    useEffect(() => {
        //    console.log(EmojiItem)
    }, [EmojiItem])
    // https://t.me/pnxbug/113
    // https://t.me/KHODRO_AKHBAR/69591
    // console.log(Price) 
    function onDismiss() {
        setTimeout(() => {
            setMemberReward(false)
            setBottomSheetState(false)

        }, 300);
    }
    const [PaymentWay, setPaymentWay] = useState('PayPal')








    useEffect(() => {
        GetProfileFunc()
    }, [])
    const [Data, setData] = useState('')
    const [CanUseWallet, setCanUseWallet] = useState(false)
    const [limit_cryptomus, setlimit_cryptomus] = useState(0)

    const GetProfileFunc = async () => {
        const Token = GetCookie('Token');

        //  let res=await GetProfile(Token)
        const MakeApiClass = new AllApi();
        let res = await MakeApiClass.GetProfile(Token)
        let AppSetting = await GameDB.AppSetting.toArray()
        if (AppSetting.length > 0) {
            setlimit_cryptomus(AppSetting[0].AppSetting.limit_cryptomus)
            // console.log(AppSetting[0].AppSetting.limit_cryptomus)
        }
        if (res.code == 200) {
            setData(res.data.user.walletBalance)
            let PriceNumber = Number(Price)
            let wallet = Number(res.data.user.walletBalance).toFixed(2)
            console.log(PriceNumber)
            console.log(res.data.user.walletBalance)
            console.log(res.data.user.walletBalance >= PriceNumber)
            if (res.data.user.walletBalance >= PriceNumber) {
                setCanUseWallet(true)
            }
        } else if (res.code == 120 || res.code == 121 || res.code == 122 || res.code == 123) {
            let name = "Token"
            let name1 = "active"
            document.cookie = name + '=; Max-Age=-99999999;';
            document.cookie = name1 + '=; Max-Age=-99999999;';


            history.push("/");
            // dispatch(setLoading(false))

        }

    }
    console.log(CanUseWallet)
    return (
        <div className='GetLinkUsername'>
            <div className='GetLinkUsernameHeader'>
                <Link to={`/SelectEmoji?Emoji=${Emoji}&Price=${Price}&Count=${Count}&_id=${_id}&sku=${sku}&ByCoin=${ByCoin}`} className="GetLinkUsernameHeaderLink">
                    <img src={Back} className='GetLinkUsernameHeaderImg' />
                </Link>
                <div className='GetLinkUsernameHeaderText'>
                    Post Link
                </div>
            </div>
            <div className='GetLinkUsernameContent'>
                <div className='GetLinkUsernameContentText1'>
                    Add the post you want to boost with reactions
                </div>
                <div className='GetLinkUsernameInputContainer'>
                    {

                        UsernameErrorEmpty ?
                            <TextField
                                error
                                id="outlined-error"
                                label="Link"
                                defaultValue="Post Link"
                                className='GetLinkUsernameInput'
                                onChange={(e) => HandleChange(e.target.value)}
                                value={Username}
                                helperText="field is empty"
                            />
                            :
                            UsernameError ?
                                <TextField
                                    error
                                    id="outlined-error"
                                    label="Link"
                                    defaultValue="Hello World"
                                    className='GetLinkUsernameInput'
                                    onChange={(e) => HandleChange(e.target.value)}
                                    value={Username}
                                    helperText="format is incorrect"
                                />
                                :
                                ServerError ?
                                    <TextField
                                        error
                                        id="outlined-error"
                                        label="Link"
                                        defaultValue="Hello World"
                                        className='GetLinkUsernameInput'
                                        onChange={(e) => HandleChange(e.target.value)}
                                        value={Username}
                                        helperText={ServerError}
                                    />
                                    :
                                    <TextField id="outlined-basic"
                                        label="Post Link"
                                        variant="outlined"
                                        className='GetLinkUsernameInput'
                                        // onChange={(e) => HandleChange(e.target.value)}
                                        onChange={(e) => HandleChange(e.target.value)}
                                        value={Username}

                                    />
                    }


                </div>


            </div>
            <div className='GetLinkUsernameFooter'>
                <div className='NoticeInSelectEmoji'>
                    <img src={warning} style={{ marginRight: '12px' }} />
                    <div className='NoticeInSelectEmojiText'>
                        Your channel must be public to receive reactions
                    </div>
                </div>
                <button
                    className={ButtonState == null || ButtonState == true
                        ? 'GetLinkUsernameFooterButtonDisable'
                        :
                        'GetLinkUsernameFooterButton'
                    }

                    disabled={ButtonState == null || ButtonState == true ? true : false}



                    onClick={() => HandleUsernameLink()}
                >
                    {MiniLoading ?
                        <div className='LoaderContainer'>
                            <div className="loadminijoin"></div>
                        </div>

                        :
                        'Next'
                    }
                </button>
            </div>
            {
                Emoji == 'true' ? <ShowPriceAndChannelCoin /> : <ShowPriceAndChannel />
            }
            <CheckUsername />

            <TooManyOrders />
            <TooManyOrdersUser />

            <ViolatingChannel />
            <BottomSheet onDismiss={onDismiss} open={BottomSheetstate}>
                <div className='RegisterBeforeBottomSheet'>

                    <div className='ShowPriceAndChannelBottomSheetBody'>
                        {
                            PaymentWay == 'Cryptomus' && CanUseWallet ?
                                <div className='ShowPriceAndChannelItem'>
                                    <div className='ShowPriceAndChannelTitle'>Balance</div>
                                    <div className='ShowPriceAndChannelValue'><span className='DollarSign'>$</span> {Number(Data).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })} </div>
                                </div>


                                : <div className='ShowPriceAndChannelItem'>
                                    <div className='ShowPriceAndChannelTitle'>&nbsp;</div>
                                    <div className='ShowPriceAndChannelValue'>&nbsp; </div>
                                </div>
                        }
                        <div className='ShowPriceAndChannelItem'>
                            <div className='ShowPriceAndChannelTitle'>Price</div>
                            {/* <div className='ShowPriceAndChannelValue'>{Price} 
                                {ByCoin == 'true' ? 
                                <span className='CoinSign'><img src={CoinBottomSheet} /></span> :
                                 IsIranian ? "T" :
                                  <span className='DollarSign'>$</span>}</div> */}
                            <div className='ShowPriceAndChannelValue'>
                                {ByCoin == 'true' ? (
                                    <>
                                        {Price}
                                        <span className='CoinSign'><img src={CoinBottomSheet} /></span>
                                    </>
                                ) : IsIranian ? (
                                    <>
                                        {Price} T
                                    </>
                                ) : (
                                    <>
                                        <span className='DollarSign'>$</span> {Price}
                                    </>
                                )}
                            </div>

                        </div>
                        <div className='ShowPriceAndChannelItem'>
                            <div className='ShowPriceAndChannelTitle'>Count</div>
                            <div className='ShowPriceAndChannelValue'>{Count.toLocaleString()}
                                {/* {Emoji} */}
                                {/* <img src={EmojiItem?.image} /> */}
                                <img
                                    width={24}
                                    height={24}
                                    src={EmojiItem?.image}
                                    style={{ marginLeft: '4px' }}
                                // alt={`Image ${index}`}
                                />
                                {/* <PersonIcon className='PersonIcon' /> */}
                            </div>
                        </div>
                        <div className='ShowPriceAndChannelItem'>
                            <div className='ShowPriceAndChannelTitle'>Post link</div>

                            <div className={`'ShowPriceAndChannelValue' ${Username.length > 24 ? 'scrolling-text-container' : ''}`}
                                style={{ width: Username.length > 24 ? "50%" : "", }}>
                                <div className={`${Username.length > 24 ? "scrolling-text" : ''}`}>{Username}</div>
                            </div>
                        </div>
                    </div>
                    <div className='RegisterBeforeBottomSheetFooter'>
                        <div className='CryptomusAdded'>
                            {
                                ByCoin != 'true' ?
                                   !IsIranian ? 
                                    <div className='CryptomusAddedInner'>
                                        {
                                            CryptoDisable ?
                                                <div onClick={() => setPaymentWay('Cryptomus')} className={PaymentWay == 'Cryptomus' ? 'CryptomusDivActive' : 'CryptomusDiv'}>
                                                    {PaymentWay == 'Cryptomus' ? <img src={Cryptoicon} /> : <img src={CryptoDisableicon} />}  Crypto
                                                </div>
                                                // <div className={'CryptomusDivDeActive'}>
                                                //     <img src={CryptoDisableicon} />   Cryptomus
                                                // </div>
                                                :
                                                <div onClick={() => setPaymentWay('Cryptomus')} className={PaymentWay == 'Cryptomus' ? 'CryptomusDivActive' : 'CryptomusDiv'}>
                                                    {PaymentWay == 'Cryptomus' ? <img src={Cryptoicon} /> : <img src={CryptoDisableicon} />}  Crypto
                                                </div>
                                        }

                                        <div onClick={() => setPaymentWay('PayPal')} className={PaymentWay == 'PayPal' ? 'PayPalDivActive' : 'PayPalDiv'}>
                                            <img src={PayPalIcon} />  PayPal
                                        </div>
                                    </div>
                                    : null
                                    : null
                            }
                            {
                                ByCoin != 'true' ?
                                    CryptoDisable ?
                                        <div className='CryptomusAddednote'>
                                            Only amounts over $1
                                        </div>
                                        : <div className='CryptomusAddednote'>
                                            &nbsp;
                                        </div>
                                    : null
                            }
                            {
                                CryptoDisable && PaymentWay != 'PayPal' ?
                                    <button className='BottomSheetShowPriceAndChannelButtonDisable' style={{ 'background': '#E0E0E0', 'color': '#616161' }} >
                                        {MiniLoading ?
                                            <div className="loadminijoin"></div>
                                            :

                                            'Pay'
                                        }

                                    </button> :
                                    <button className='BottomSheetShowPriceAndChannelButton' onClick={() => Pay(data)}>
                                        {MiniLoading ?
                                            <div className="loadminijoin"></div>
                                            :

                                            'Pay'
                                        }

                                    </button>
                            }
                        </div>
                        {/* <a href={`https://api.membersgram.com/main/v1/webapp/purchasememberpaypal?data=${data}`}>
                                    123
                                </a> */}
                        {/* <button className='BottomSheetCancelButton' onClick={() => dispatch(setBottomSheetCheckUsername(false))}>Cancel</button> */}
                        {/* <button className='BottomSheetShowPriceAndChannelButton' onClick={() => Pay(data)}>
                            {MiniLoading ?
                                <div className="loadminijoin"></div>
                                :
                                'Pay'
                            }

                        </button> */}
                    </div>
                </div>
            </BottomSheet>
            <BottomSheet onDismiss={onDismiss}
                open={MemberReward}
            //   open={true}
            >
                <div className='RegisterBeforeBottomSheet'>
                    <div className='RegisterBeforeBottomSheetHeader'>
                        <div className={`RegisterBeforeBottomSheetHeaderText `}>
                            <div >
                                🎉 Reward Claimed  🎉
                            </div>
                        </div>
                    </div>
                    <div className='RegisterBeforeBottomSheetBody' style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                        {MemberRewardCount}
                        {/* <img width={18} height={18} src={Member} style={{ margin: "0 4px 0 4px" }} />   */}
                        {Emoji}
                        are sending to {LastUsername}
                    </div>
                    <div className='RegisterBeforeBottomSheetFooter'>
                        <button className='BottomSheetLoginButton' style={{ width: "100%" }} onClick={() => { setMemberReward(false); history.push('/Home?Status=Member') }}>Got it</button>
                    </div>
                </div>
            </BottomSheet>


            <UnsuccessfulPayment />
            <SuccessfulPayment UserNameForOrder={Username} Mode="react" CountCrypto={Count} Emoji={Emoji} />
        </div>
    )
}

export default ReactionGetPostLink